import { render, staticRenderFns } from "./zxEchart.vue?vue&type=template&id=29a4f0c2&scoped=true&"
import script from "./zxEchart.vue?vue&type=script&lang=js&"
export * from "./zxEchart.vue?vue&type=script&lang=js&"
import style0 from "./zxEchart.vue?vue&type=style&index=0&id=29a4f0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a4f0c2",
  null
  
)

export default component.exports